"use client";
import { jsxs as e, jsx as o } from "react/jsx-runtime";
import { memo as l } from "react";
import n from "../components/Icon/SvgIcon.js";
const r = (t) => /* @__PURE__ */ e(
  n,
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ...t,
    children: [
      /* @__PURE__ */ o(
        "path",
        {
          fill: "#fff",
          d: "M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10"
        }
      ),
      /* @__PURE__ */ o(
        "path",
        {
          fill: "currentColor",
          d: "M12 22a9.7 9.7 0 0 1-3.875-.788 10.1 10.1 0 0 1-3.188-2.15 10.1 10.1 0 0 1-2.15-3.187A9.7 9.7 0 0 1 2 12a9.7 9.7 0 0 1 .788-3.9 10 10 0 0 1 2.15-3.175 10.3 10.3 0 0 1 3.187-2.137A9.7 9.7 0 0 1 12 2a9.7 9.7 0 0 1 3.9.788 10.1 10.1 0 0 1 3.175 2.137q1.35 1.35 2.137 3.175A9.7 9.7 0 0 1 22 12a9.7 9.7 0 0 1-.788 3.875 10.3 10.3 0 0 1-2.137 3.188 10 10 0 0 1-3.175 2.15A9.7 9.7 0 0 1 12 22m0-1.5q3.55 0 6.025-2.488T20.5 12q0-3.55-2.475-6.025T12 3.5q-3.525 0-6.013 2.475Q3.501 8.45 3.5 12q0 3.525 2.487 6.012Q8.475 20.5 12 20.5"
        }
      ),
      /* @__PURE__ */ o(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2m0 18c-4.4 0-8-3.6-8-8s3.6-8 8-8 8 3.6 8 8-3.6 8-8 8",
          clipRule: "evenodd"
        }
      )
    ]
  }
), a = l(r);
export {
  a as RadioButtonUnchecked,
  a as default
};
